import { render, staticRenderFns } from "./GroupSelect.vue?vue&type=template&id=fddffbe0&scoped=true&"
import script from "./GroupSelect.vue?vue&type=script&lang=js&"
export * from "./GroupSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fddffbe0",
  null
  
)

export default component.exports